import { useMemo } from "react";
import { FxIdWebFeaturesGamesChooseGameResponsePublicGameData } from "../../Api/gen";

export const useNormalizedViewportSize = (
	gameConfig: FxIdWebFeaturesGamesChooseGameResponsePublicGameData,
	width: number,
	height: number
) => {
	const viewportPresentation = gameConfig.ViewportPresentation;
	return useMemo(() => {
		if (viewportPresentation == null) return { width, height };

		const minRatio =
			(viewportPresentation.MinRatio?.Width ?? width) / (viewportPresentation.MinRatio?.Height ?? height);
		const maxRatio =
			(viewportPresentation.MaxRatio?.Width ?? width) / (viewportPresentation.MaxRatio?.Height ?? height);
		const ratio = width / height;

		const normalizedWidth = ratio > maxRatio ? height * maxRatio : width;
		const normalizedHeight = ratio < minRatio ? width * (1 / minRatio) : height;

		let finalWidth = normalizedWidth;
		let finalHeight = normalizedHeight;

		if (viewportPresentation.MinSize) {
			const minSizeWidth = viewportPresentation.MinSize.Width ?? 0;
			const minSizeHeight = viewportPresentation.MinSize.Height ?? 0;
			if (finalWidth < minSizeWidth) {
				finalWidth = minSizeWidth;
			}
			if (finalHeight < minSizeHeight) {
				finalHeight = minSizeHeight;
			}
		}

		if (viewportPresentation.MaxSize) {
			const maxSizeWidth = viewportPresentation.MaxSize.Width ?? Infinity;
			const maxSizeHeight = viewportPresentation.MaxSize.Height ?? Infinity;
			if (finalWidth > maxSizeWidth) {
				finalWidth = maxSizeWidth;
			}
			if (finalHeight > maxSizeHeight) {
				finalHeight = maxSizeHeight;
			}
		}

		return { width: finalWidth, height: finalHeight };
	}, [height, viewportPresentation, width]);
};
